import React from 'react';
import {useLanguageStore} from "../../store/languageStore";

export default function AboutJidar({data}) {
    const {language} = useLanguageStore()
    const isArabic = language === 'ar'

    // Check if data exists before accessing properties
    if (!data || !data.sections) {
        return <div className="bg-gray-100 p-12 rounded-lg max-w-7xl mx-auto">Loading...</div>;
    }

    return (
        <div className="bg-gray-100 p-12 rounded-lg max-w-7xl mx-auto" dir={isArabic ? 'rtl' : 'ltr'}>
            <h2 className="text-2xl font-bold mb-8 text-gray-800">
                {isArabic ? data.title_ar : data.title_en}
            </h2>

            <div className="grid grid-cols-1 lg:grid-cols-5 gap-8">
                {/* First Row */}
                <div className="col-span-1">
                    {/* Empty div for layout */}
                </div>
                <div className="col-span-4 text-justify">
                    <p className="text-gray-700">
                        {isArabic ? data?.sections[0]?.text_ar : data?.sections[0]?.text_en || ''}
                    </p>
                </div>
            </div>

            {/* Second Row */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mt-16">
                <div className="col-span-1 ">
                    <div className="overflow-hidden rounded-lg">
                        <img loading="lazy"
                            src={data?.sections[0]?.image}
                            alt="Modern construction project"
                            className="w-full h-full object-cover"
                        />
                    </div>
                </div>
                <div className="col-span-1 flex items-center order-2 lg:order-1">
                    <p className="text-gray-700">
                        {isArabic ? data?.sections[1]?.text_ar : data?.sections[1]?.text_en || ''}
                    </p>
                </div>
            </div>

            {/* Third Row */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mt-16">
                <div className="col-span-1 flex flex-col justify-center order-2 lg:order-1">
                    <p className="text-gray-700 mb-8">
                        {isArabic ? data?.sections[2]?.text_ar : data?.sections[2]?.text_en || ''}
                    </p>
                </div>
                <div className="col-span-1 order-1 lg:order-2">
                    <div className="overflow-hidden rounded-lg">
                        <img loading="lazy"
                            src={data?.sections[1]?.image}
                            alt="Modern construction project"
                            className="w-full h-full object-cover"
                        />
                    </div>
                </div>
            </div>

            {/* Fourth Row */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mt-16">
                <div className="col-span-1">
                    <div className="overflow-hidden rounded-lg">
                        <img loading="lazy"
                            src={data?.sections[2]?.image}
                            alt="Modern construction project"
                            className="w-full  object-cover"
                        />
                    </div>
                </div>
                <div className="col-span-1 flex items-center">
                    <p className="text-gray-700">
                        {isArabic ? data?.sections[3]?.text_ar : data?.sections[3]?.text_en || ''}
                    </p>
                </div>
            </div>
        </div>
    );
}